/**
 * AC Custom JavaScript
 * Custom functionality for Yellow Bird Coffee theme
 */

document.addEventListener('DOMContentLoaded', function() {
  
  // Add custom functionality here as needed
  
});
